// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { chargeSchema } from '@/billing/api/types';
import { z } from 'zod';

const cancelChargeResponseSchema = z
  .object({
    data: chargeSchema,
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({ ...response, charge: data }));

type CancelChargeResponse = z.infer<typeof cancelChargeResponseSchema>;

export interface CancelChargeInput {
  chargeKey: string;
  // Null means "no reason provided" — an empty string from the dialog is
  // coerced to null before reaching this layer so the server sees a
  // single canonical shape.
  cancellationReason: string | null;
}

export async function cancelCharge(
  input: CancelChargeInput
): Promise<CancelChargeResponse> {
  const url = `/v1/charge/${input.chargeKey}/cancel`;
  const response = await api.post(url, {
    cancellationReason: input.cancellationReason,
  });

  return parseResponse(cancelChargeResponseSchema, response.data, {
    schemaName: 'CancelCharge',
    endpoint: url,
  });
}
